import outdent from "outdent";
import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const trellix = defineConnector({
  identifier: "trellix",
  name: "Trellix",
  tagLine: "Extended detection and response",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.manage\\.trellix\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content: outdent`
            1. Log in to the [Trellix Developer Portal](https://developer.manage.trellix.com)
            2. Navigate to **Self Service > API Access Management**
            3. Create a new API client to obtain your **Client ID**, **Client Secret**, and **API Key**
          `,
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          helperText: "Your tenant-level x-api-key.",
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () =>
      "https://auth.trellix.com/auth/realms/IAM/protocol/openid-connect/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.manage.trellix.com/epo/v2/devices?$top=1",
      expectedStatus: [200, 403],
    }),
  },
});
